export default {
  title: 'Belasting & Valuta',
  subtitle: 'Beheer de belastingcategorieën die worden gebruikt voor de prijsstelling van uw menu-items.',
};
